import startCase from 'lodash/startCase'
import isString from 'lodash/isString'
import type {RadioList} from '../types'

export const mapRadioList = (radioList: RadioList) =>
  (radioList ?? []).map((value) => {
    if (!isString(value)) return value
    return {title: startCase(value), value}
  })

export type {RadioList}
